import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "settings",
  "use": "settings-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"settings\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7 3h10a4 4 0 010 8H7a4 4 0 110-8zm0 6a2 2 0 100-4 2 2 0 000 4z\" /><path opacity=\".3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7 13h10a4 4 0 010 8H7a4 4 0 010-8zm10 6a2 2 0 100-4 2 2 0 000 4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol